import styled from "styled-components"
import {DESKTOP_BREAKPOINT} from "manager/views/components/Settlement/constants"

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 100%;
  
  @media screen and ${DESKTOP_BREAKPOINT} {
    grid-template-columns: 50% 50%;
    
    > *:nth-child(odd) {
      justify-self: left;
    }
    > *:nth-child(even) {
        justify-self: right;
    }
  }
`

export const GridCell = styled.div`
  display: flex;
  
  > *:not(:first-child) {
    margin-left: 15px;
  }
  
  @media screen and ${DESKTOP_BREAKPOINT} {
    max-width: 384px;
    width: 100%;
  }
`
